import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal/Modal';

import type IConfirmModal from './interfaces/IConfirmModal';

export default function ConfirmModal({
  open,
  title,
  onReject,
  onConfirm,
  isLoading,
}: IConfirmModal) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={title ?? t('common.enterNewName')}
      closeTitle={t('common.cancel')}
      confirmTitle={t('common.save')}
      onReject={onReject}
      onConfirm={onConfirm}
      isLoading={isLoading}
    />
  );
}
